<template lang="pug">
    v-card
        v-snackbar(
            v-model="snackbar"
            :timeout="10000"
            color='error'
        ) {{ snackbarMessage }}
        v-toolbar(dark dense color="red" class="navFixed" width="100%")
            v-toolbar-title i-Permit Preview    
            v-spacer
            v-toolbar-title(v-if="ip.ipPengesahan && ip.ipStatus !== 10 && getApproveStatus(ip.ipPengesahan.ipWorkflow) == '7'") Approved on {{formatDate(getApproveDate(ip.ipPengesahan.ipWorkflow))}}
            v-toolbar-title(v-else-if="ip.ipStatus !== 10 && getApproveStatus(ip.ipWorkflow) == '7'") Approved on {{formatDate(getApproveDate(ip.ipWorkflow))}}
            v-toolbar-title(v-if="getApproveStatus(ip.ipWorkflow) == '8'") Rejected on {{formatDate(getApproveDate(ip.ipWorkflow))}}
            v-toolbar-items
                v-btn(v-if="dialogType == 'approval' && isCurrentApprover()" @click.stop="approvalDialog = true" color="red" depressed title='Approval' class="blink") 
                    v-icon(title="Approval") assignment_turned_in
                    | &nbsp; Approval
                v-dialog(v-if="dialogType == 'approval' && isCurrentApprover()" v-model="approvalDialog" persistent max-width="500px")
                    v-card()
                        v-card-title(class="headline grey lighten-2") Approval Form
                        v-card-text
                            v-layout(wrap)
                                v-flex(xs12)
                                    v-radio-group(v-model="approval" row)
                                        v-radio(label="Approve" color="success" value="7")
                                        v-radio(v-if="ip.ipStatus !== 10" label="Reject" color="red" value="8")
                                        v-radio(v-if="ip.ipStatus == 10" label="Need Review" color="yellow darken-4" value="11")
                                        v-radio(v-else label="Need Review" color="yellow darken-4" value="3")
                                v-flex(xs12)
                                    v-textarea(
                                        v-model="comment"
                                        filled
                                        label="Comment (Optional)"
                                        value=""
                                    )
                        v-card-actions
                            v-spacer
                            v-btn(text @click.native="approvalDialog = false") Close
                            v-btn(:disabled="!approval" text :loading="approvalDialog2" color="blue darken-1" @click="approvalDialog2 = true") Submit
                            v-dialog(
                                v-model="approvalDialog2"
                                hide-overlay
                                persistent
                                width="300")
                                v-card(color="primary" dark)
                                v-card-text Processing. Please wait!
                                    v-progress-linear(indeterminate color="white" class="mb-0")
                v-btn(v-if="this.ip.ipStatus == 4 || this.ip.ipStatus == 8" @click="shareIP();" color="red" depressed title="Share" )
                    v-icon share
                    | &nbsp; Share
                    v-dialog(v-model="share" persistent max-width="400px")
                        v-card
                            v-card-title(class="headline grey lighten-3") Share
                            v-flex(class="headline grey lighten-3")
                                v-row(no-gutters align="center" justify="center")
                                    ShareNetwork(
                                        v-for="network in networks"
                                        :key="network.key"
                                        class="ma-3 pa-3 green"
                                        :network="network.network"
                                        style="border-radius: 10px; box-shadow: -2px 4px #888888;"
                                        :url="shortenUrl"
                                        :title="sharing.title"
                                        :description="sharing.description"
                                    ) 
                                        i(:class="network.icon" style="color:white")
                                        span(class="ma-3" style="color:white") {{ network.name }}
                            v-spacer
                            v-flex(class="text-end headline grey lighten-2")
                                v-btn(color="blue darken-1" text @click.native="share = false") Close
                v-btn(@click="ip.ipStatus == 4 || ip.ipStatus == 8 ? print = true : printIP(ip._id)" color="red" depressed title="Print" )
                    v-icon print
                    | &nbsp; Print
                    v-dialog(v-model="print" persistent max-width="400px")
                        v-card
                            v-card-title(class="headline grey lighten-3") Print Document
                            v-alert(:value='true' color="success")
                                h3(style="text-align: center; font-weight:normal; color: white;") To save the trees, please think to share it rather than print.
                            v-flex(class="headline grey lighten-3")
                                v-row(no-gutters align="center" justify="center")
                                    v-btn(@click="printIP(ip._id); print = false;" class="ma-3 pa-3 red darken-2" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                        i(class="far fah fa-lg fa fa-print" style="color:white")
                                        span(class="ma-3" style="color:white") Print
                                    v-btn(@click="print = false; shareIP();" class="ma-3 pa-3 green" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                        i(class="far fah fa-lg fa fa-share-alt" style="color:white")
                                        span(class="ma-3" style="color:white") Share
                            v-spacer
                            v-flex(class="text-end headline grey lighten-2")
                                v-btn(color="blue darken-1" text @click.native="print = false") Close
                v-btn(onClick="javascript:window.close()" color="red" depressed)
                    v-icon(title="Close") cancel
                    | &nbsp; Close
        v-list(class="print-bg padTop60")
            div(:id="ip._id")
                .page(size="Auto")
                    div(class="view-width" style="font-size:10px;")
                        div(v-if="ip.ipStatus == 4" id="background")
                            p(class="fontWatermarkUp" ) {{ip.ipNo}}
                            img(src="../assets/Approve.png" class="imgWatermark")
                            p(class="fontWatermarkDown" ) {{ip.ipNo}}
                        div(v-else-if="ip.ipStatus == 8" id="background")
                            p(class="fontWatermarkUp" ) {{ip.ipNo}}
                            img(src="../assets/reject.png" class="imgWatermark")
                            p(class="fontWatermarkDown" ) {{ip.ipNo}}
                        div(v-else-if="ip.ipStatus == 13" id="background")
                            p(class="fontWatermarkUp" ) {{ip.ipNo}}
                            img(src="../assets/Auto Canceled.png" class="imgWatermark")
                            p(class="fontWatermarkDown" ) {{ip.ipNo}}
                        div(v-else-if="ip.ipStatus == 14" id="background")
                            p(class="fontWatermarkUp" ) {{ip.ipNo}}
                            img(src="../assets/Auto Rejected.png" class="imgWatermark")
                            p(class="fontWatermarkDown" ) {{ip.ipNo}}
                        div(v-else-if="ip.ipStatus == 15" id="background")
                            p(class="fontWatermarkUp" ) {{ip.ipNo}}
                            img(src="../assets/Auto Dropped.png" class="imgWatermark")
                            p(class="fontWatermarkDown" ) {{ip.ipNo}}
                        div(v-else-if="ip.ipStatus == 12" id="background")
                            p(class="fontWatermarkUp" ) {{ip.ipNo}}
                            img(src="../assets/Done.png" class="imgWatermark")
                            p(class="fontWatermarkDown" ) {{ip.ipNo}}
                        table(class="view-width tableInput" style="margin-top:10px;")
                            tbody
                                tr
                                    td( class="align-center" width="150" rowspan="3")
                                        img(class="verMiddle" src="../assets/BORNEO-INDOBARA.jpg" width="120px")
                                    td(class="align-center") SINARMAS MINING SYSTEM
                                    td( class="align-center" width="150" rowspan="3") 
                                        img(class="verMiddle" :src="`${API_URL}/qr/generate/?ipNo=${ip.ipNo}&formCode=${ip.ipForm}`" style="width:80px;margin:2px 0;")
                                tr
                                    td(class="align-center") FORMULIR
                                tr
                                    td(class="align-center") {{ formName[ip.ipForm] }}

                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable" colspan="6") I. INFORMASI UMUM
                                tr
                                    td(width="150" class="headerTable") Judul Pekerjaan
                                    td(colspan="3") {{ ip.ipJudulPekerjaan }}
                                tr
                                    td(class="headerTable") Nama Pemegang Izin/Pengawas Operasional
                                    td {{ ip.ipPemegangIzin.name }}
                                    td(width="100" class="headerTable") Departemen
                                    td {{ ip.ipDeptDivisi }}
                                tr
                                    td(width="150" class="headerTable") Lokasi Pekerjaan
                                    td {{ locations.join(', ') }}
                                    td(width="100" class="headerTable") Divisi
                                    td {{ ip.ipDivisi }}
                                tr
                                    td(width="100" class="headerTable") Sub Lokasi
                                    td {{ ip.ipSubLokasi }}                           
                                    td(class="headerTable") Perusahaan
                                    td(colspan="3") {{ ip.ipPerusahaan }}
                                tr
                                    td(class="headerTable") Tanggal Perizinan
                                    td {{ formatDate(ip.ipPelaksanaanStart) }} s/d {{ formatDate(ip.ipPelaksanaanEnd) }}
                                    td(class="headerTable") Nomor Izin Kerja
                                    td(colspan="3") {{ ip.ipNo }}                           
                        
                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            thead
                                tr
                                    td(class="headerTable" width="120" colspan="4") II. DETAIL PEKERJA
                            tbody
                                tr
                                    td(class="headerTable" width="4%") No
                                    td(class="headerTable align-center" width="32%") Nama Entrans
                                    td(class="headerTable align-center" width="32%") Jabatan/Posisi
                                    td(class="headerTable align-center" width="32%") Kompetensi/Pelatihan
                                tr
                                    td 1.
                                    td {{ ip.ipNamaEntrans1 }}
                                    td {{ ip.ipJabatanEntrans1 }}
                                    td {{ ip.ipKompetensiEntrans1 }}
                                tr
                                    td 2.
                                    td {{ ip.ipNamaEntrans2 }}
                                    td {{ ip.ipJabatanEntrans2 }}
                                    td {{ ip.ipKompetensiEntrans2 }}
                                tr
                                    td 3.
                                    td {{ ip.ipNamaEntrans3 }}
                                    td {{ ip.ipJabatanEntrans3 }}
                                    td {{ ip.ipKompetensiEntrans3 }}
                                tr
                                    td 4.
                                    td {{ ip.ipNamaEntrans4 }}
                                    td {{ ip.ipJabatanEntrans4 }}
                                    td {{ ip.ipKompetensiEntrans4 }}
                                tr
                                    td(class="headerTable" width="4%") No
                                    td(class="headerTable align-center" width="32%") Nama Attendant (s)
                                    td(class="headerTable align-center" width="32%") Jabatan/Posisi
                                    td(class="headerTable align-center" width="32%") Kompetensi/Pelatihan
                                tr
                                    td 1.
                                    td {{ ip.ipNamaAttendant1 }}
                                    td {{ ip.ipJabatanAttendant1 }}
                                    td {{ ip.ipKompetensiAttendant1 }}
                                tr
                                    td 2.
                                    td {{ ip.ipNamaAttendant2 }}
                                    td {{ ip.ipJabatanAttendant2 }}
                                    td {{ ip.ipKompetensiAttendant2 }}
                                tr
                                    td 3.
                                    td {{ ip.ipNamaAttendant3 }}
                                    td {{ ip.ipJabatanAttendant3 }}
                                    td {{ ip.ipKompetensiAttendant3 }}
                                tr
                                    td 4.
                                    td {{ ip.ipNamaAttendant4 }}
                                    td {{ ip.ipJabatanAttendant4 }}
                                    td {{ ip.ipKompetensiAttendant4 }}

                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable") III. DESKRIPSI DETAIL PEKERJAAN (spesifik dan tidak boleh ada tambahan kegiatan diluar cakupan yang tertera dalam izin ini)
                                tr
                                    td
                                        div(v-html="ip.ipDetailPekerjaan" class="ck-content")
                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable" colspan="4") IV.	POTENSI BAHAYA/RISIKO YANG MUNGKIN ADA & PENGENDALIANNYA
                                tr
                                    td(class="headerTable pl-2" rowspan="4" width="5%") Potensi Bahaya Umum/Risiko
                                template(v-for="(item, key) in potensiBahayaOptions")
                                    template(v-if="key % 3 == 0")
                                        tr
                                            td(width="20%") 
                                                img(v-if="potensiBahayaDetail[key]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ potensiBahayaOptions[key] }}
                                            td(width="20%") 
                                                img(v-if="potensiBahayaDetail[key+1]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ potensiBahayaOptions[key+1] }}
                                            td(width="20%") 
                                                img(v-if="potensiBahayaDetail[key+2]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ potensiBahayaOptions[key+2] }}
                        table( class="view-width tableCollapse autoPageBreak mytable-footer")
                            tbody
                                tr
                                    td(class="pl-2" rowspan="4" width="1.57%" style="background-color: #cccccc") Pengendalian Bahaya/Risiko
                                template(v-for="(item, key) in pengendalianBahayaOptions")
                                    template(v-if="key % 2 == 0")
                                        tr
                                            td(width="20%")
                                                img(v-if="pengendalianBahayaDetail[key]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ pengendalianBahayaOptions[key] }}
                                            td(width="20%") 
                                                img(v-if="pengendalianBahayaDetail[key+1]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ pengendalianBahayaOptions[key+1] }}
                                tr
                                    td(colspan="2")
                                        img(v-if="izinKerjaKhususLainnyaDetail" src="../assets/check.png" width="10" class="mr-1")
                                        img(v-else src="../assets/close.png" width="10" class="mr-1")
                                        span Izin kerja khusus lainnya : {{ izinKerjaKhususLainnyaDetail ? getIzinKerjaKhususLainnya : ''}}
                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable" colspan="8") V. PERSYARATAN KHUSUS UNTUK PENCEGAHAN INSIDEN 
                                tr
                                    td(colspan="8") Berikan tanda check pada kolom di bawah Ya (Y) / Tidak (T) / Tidak Perlu (TP)
                                tr
                                    td(class="align-center headerTable") Daftar periksa
                                    td(class="align-center headerTable" width="40") Y
                                    td(class="align-center headerTable" width="40") T
                                    td(class="align-center headerTable" width="40") TP
                                    td(class="align-center headerTable") Daftar periksa
                                    td(class="align-center headerTable" width="40") Y
                                    td(class="align-center headerTable" width="40") T
                                    td(class="align-center headerTable" width="40") TP
                                tr(v-if="!ip.ipPersonilKompeten")
                                    td Prosedur kerja (PPO / AKA) sudah dibuat?
                                    td(class="align-center")
                                        img(v-if="ip.ipPpoAka == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPpoAka == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPpoAka == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Apakah ada pekerjaan panas dalam ruang terbatas?
                                    td(class="align-center")
                                        img(v-if="ip.ipAdaPanas == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipAdaPanas == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipAdaPanas == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="!ip.ipPersonilKompeten")
                                    td Pengawas pekerjaan ada sepanjang waktu?
                                    td(class="align-center")
                                        img(v-if="ip.ipPengawasPekerjaan == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPengawasPekerjaan == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPengawasPekerjaan == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Peralatan darurat tersedia dan memadai?
                                    td(class="align-center")
                                        img(v-if="ip.ipPeralatanDarurat == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPeralatanDarurat == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPeralatanDarurat == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="!ip.ipPersonilKompeten")
                                    td Kondisi oksigen dalam ruangan diperiksa?
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiOksigen == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiOksigen == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiOksigen == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Alat bantu pernafasan tersedia?
                                    td(class="align-center")
                                        img(v-if="ip.ipAlatBantuPernafasan == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipAlatBantuPernafasan == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipAlatBantuPernafasan == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="!ip.ipPersonilKompeten")
                                    td Ada material mudah terbakar dalam radius 11 meter?
                                    td(class="align-center")
                                        img(v-if="ip.ipMaterialMudahTerbakar == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipMaterialMudahTerbakar == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipMaterialMudahTerbakar == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Safety harness diperlukan dan tersedia?
                                    td(class="align-center")
                                        img(v-if="ip.ipSafetyHarness == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipSafetyHarness == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipSafetyHarness == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="!ip.ipPersonilKompeten")
                                    td Area sudah dibarikade?
                                    td(class="align-center")
                                        img(v-if="ip.ipBarikade == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipBarikade == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipBarikade == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Masker oksigen tersedia?
                                    td(class="align-center")
                                        img(v-if="ip.ipMasker == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipMasker == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipMasker == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="!ip.ipPersonilKompeten")
                                    td Rambu memadai dan sudah terpasang?
                                    td(class="align-center")
                                        img(v-if="ip.ipRambuMemadai == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipRambuMemadai == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipRambuMemadai == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Penguncian/isolasi energi berbahaya dilakukan?
                                    td(class="align-center")
                                        img(v-if="ip.ipIsolasi == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipIsolasi == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipIsolasi == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="!ip.ipPersonilKompeten")
                                    td Pendeteksi gas personal ada?
                                    td(class="align-center")
                                        img(v-if="ip.ipPendeteksiGas == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPendeteksiGas == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPendeteksiGas == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td APAR tersedia dan memadai?
                                    td(class="align-center")
                                        img(v-if="ip.ipApar == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipApar == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipApar == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="!ip.ipPersonilKompeten")
                                    td Pencahayaan dalam ruang terbatas memadai?
                                    td(class="align-center")
                                        img(v-if="ip.ipPencahayaanRuang == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPencahayaanRuang == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPencahayaanRuang == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Apakah tangga diperlukan?
                                    td(class="align-center")
                                        img(v-if="ip.ipButuhTangga == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipButuhTangga == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipButuhTangga == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                //- 
                                tr(v-if="ip.ipPersonilKompeten")
                                    td Prosedur kerja (PPO / AKA) sudah dibuat?
                                    td(class="align-center")
                                        img(v-if="ip.ipPpoAka == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPpoAka == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPpoAka == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Apakah ada pekerjaan panas dalam ruang terbatas?
                                    td(class="align-center")
                                        img(v-if="ip.ipAdaPanas == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipAdaPanas == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipAdaPanas == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="ip.ipPersonilKompeten")
                                    td Personil telah kompeten melaksanakan pekerjaan di ruang terbatas?
                                    td(class="align-center")
                                        img(v-if="ip.ipPersonilKompeten == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPersonilKompeten == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPersonilKompeten == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Peralatan darurat tersedia dan memadai?
                                    td(class="align-center")
                                        img(v-if="ip.ipPeralatanDarurat == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPeralatanDarurat == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPeralatanDarurat == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="ip.ipPersonilKompeten")
                                    td Pengawas pekerjaan ada sepanjang waktu?
                                    td(class="align-center")
                                        img(v-if="ip.ipPengawasPekerjaan == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPengawasPekerjaan == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPengawasPekerjaan == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else)  
                                    td Alat bantu pernafasan tersedia?
                                    td(class="align-center")
                                        img(v-if="ip.ipAlatBantuPernafasan == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipAlatBantuPernafasan == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipAlatBantuPernafasan == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="ip.ipPersonilKompeten")
                                    td Kondisi oksigen dalam ruangan diperiksa?
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiOksigen == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiOksigen == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiOksigen == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else)
                                    td Safety harness diperlukan dan tersedia?
                                    td(class="align-center")
                                        img(v-if="ip.ipSafetyHarness == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipSafetyHarness == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipSafetyHarness == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="ip.ipPersonilKompeten")
                                    td Ada material mudah terbakar dalam radius 11 meter?
                                    td(class="align-center")
                                        img(v-if="ip.ipMaterialMudahTerbakar == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipMaterialMudahTerbakar == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipMaterialMudahTerbakar == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Masker oksigen tersedia?
                                    td(class="align-center")
                                        img(v-if="ip.ipMasker == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipMasker == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipMasker == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="ip.ipPersonilKompeten")
                                    td Area sudah dibarikade?
                                    td(class="align-center")
                                        img(v-if="ip.ipBarikade == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipBarikade == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipBarikade == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Penguncian/isolasi energi berbahaya dilakukan?
                                    td(class="align-center")
                                        img(v-if="ip.ipIsolasi == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipIsolasi == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipIsolasi == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="ip.ipPersonilKompeten")
                                    td Rambu memadai dan sudah terpasang?
                                    td(class="align-center")
                                        img(v-if="ip.ipRambuMemadai == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipRambuMemadai == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipRambuMemadai == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td APAR tersedia dan memadai?
                                    td(class="align-center")
                                        img(v-if="ip.ipApar == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipApar == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipApar == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="ip.ipPersonilKompeten")
                                    td Pendeteksi gas personal ada?
                                    td(class="align-center")
                                        img(v-if="ip.ipPendeteksiGas == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPendeteksiGas == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPendeteksiGas == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Apakah tangga diperlukan?
                                    td(class="align-center")
                                        img(v-if="ip.ipButuhTangga == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipButuhTangga == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipButuhTangga == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr(v-if="ip.ipPersonilKompeten")
                                    td Pencahayaan dalam ruang terbatas memadai?
                                    td(class="align-center")
                                        img(v-if="ip.ipPencahayaanRuang == 'Ya'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPencahayaanRuang == 'Tidak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipPencahayaanRuang == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else)
                                    td(colspan="4" class="headerTable") 
                                tr
                        table(style="margin-top:10px;width:3cm;border: 1px solid black;" class="autoPageBreak")
                            tbody(v-if="ip.ipAttachmentFiles.docPendukung") 
                                v-btn(tile text @click="download(ip.ipAttachmentFiles.docPendukung)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-family: 'Arial Narrow';font-weight:normal" height="auto") 
                                    tr
                                        td(style="padding-left:1px" ) 
                                            v-icon(small) mdi-attachment
                                        td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                        td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                                            img(src="../assets/check.png" width="10" )
                            tbody(v-else)
                                tr
                                    td(style="padding-left:1px" ) 
                                        v-icon(small) mdi-attachment
                                    td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                    td(style="background-color: rgb(204,204,204);padding-right:4px" )
                                        img(src="../assets/close.png" width="10" class="verMiddle")

                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable" colspan="3") VI.	MONITORING UDARA/GAS <br/> (Dilakukan sebelum perizinan ini diajukan (Initial) dan saat pekerjaan dilakukan), jika kolom telah penuh, gunakan formulir pemeriksaan kualitas udara di ruang terbatas)
                                tr
                                    td(class="headerTable pl-2" width="5%") Nama Petugas Pemeriksa
                                    td(width="20%") {{ ip.ipNamaPetugasMonitoringGas }}
                                tr
                                    td(class="headerTable pl-2" width="5%") Jabatan/Posisi
                                    td(width="20%") {{ ip.ipJabatanPetugasMonitoringGas }}
                        table( class="view-width tableCollapse autoPageBreak mytable-footer")
                            tbody
                                tr
                                    td(class="pl-2 align-center" rowspan="2" style="background-color: #cccccc") Parameter
                                    td(class="pl-2 align-center" rowspan="2" style="background-color: #cccccc") Standar
                                    td(class="pl-2 align-center" colspan="5" style="background-color: #cccccc") Tanggal & Waktu
                                tr
                                    td(width="10%" class="align-center") Initial
                                    td(width="10%") 
                                    td(width="10%") 
                                    td(width="10%") 
                                    td(width="10%") 
                                tr
                                    td(width="10%") Oksigen
                                    td(width="10%") 19,5% - 23,5%
                                    td(width="10%") {{ ip.ipTesOksigenAwal }}
                                    td(width="10%")
                                    td(width="10%")
                                    td(width="10%")
                                    td(width="10%")
                                tr
                                    td(width="10%") Flammable
                                    td(width="10%") <5% LEL
                                    td(width="10%") {{ ip.ipTesFlammableAwal }}
                                    td(width="10%")
                                    td(width="10%")
                                    td(width="10%")
                                    td(width="10%")
                                tr
                                    td(width="10%") CO
                                    td(width="10%") 25 ppm (8 jam)
                                    td(width="10%") {{ ip.ipTesCOAwal }}
                                    td(width="10%")
                                    td(width="10%")
                                    td(width="10%")
                                    td(width="10%")
                                tr
                                    td(width="10%") H2S
                                    td(width="10%") 1 ppm (8 jam)
                                    td(width="10%") {{ ip.ipTesH2SAwal }}
                                    td(width="10%")
                                    td(width="10%")
                                    td(width="10%")
                                    td(width="10%")

                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable" colspan="5") VII. APD & ALAT KESELAMATAN
                                tr
                                    td(class="headerTable pl-2" rowspan="4" width="5%") Alat Keselamatan
                                template(v-for="(item, key) in alatKeselamatanOptions")
                                    template(v-if="key % 4 == 0")
                                        tr
                                            td(width="20%") 
                                                img(v-if="alatKeselamatanDetail[key]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ alatKeselamatanOptions[key] }}
                                            td(width="20%") 
                                                img(v-if="alatKeselamatanDetail[key+1]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ alatKeselamatanOptions[key+1] }}
                                            td(width="20%")
                                                img(v-if="alatKeselamatanDetail[key+2]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ alatKeselamatanOptions[key+2] }}
                                            td(width="20%")
                                                img(v-if="alatKeselamatanDetail[key+3]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else-if="alatKeselamatanOptions[key+3]" src="../assets/close.png" width="10" class="mr-1")
                                                span {{ alatKeselamatanOptions[key+3] }}
                        table( class="view-width tableCollapse autoPageBreak mytable-footer")
                            tbody
                                tr
                                    td(class="pl-2" rowspan="6" width="4.4%" style="background-color: #cccccc") Alat Pelindung Diri
                                template(v-for="(item, key) in apdOptions")
                                    template(v-if="key % 3 == 0")
                                        tr
                                            td(width="20%") 
                                                img(v-if="apdDetail[key]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ apdOptions[key] }}
                                            td(width="20%")
                                                img(v-if="apdDetail[key+1]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ apdOptions[key+1] }}
                                            td(width="20%")
                                                img(v-if="apdDetail[key+2]" src="../assets/check.png" width="10" class="mr-1")
                                                img(v-else src="../assets/close.png" width="10" class="mr-1")
                                                span {{ apdOptions[key+2] }}

                        table(v-if="ip.ipWorkflow.length == 6" class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable pl-2" colspan="6") VIII. PENGESAHAN
                                tr
                                    td(class="pl-2" colspan="6") 
                                        b Catatan:
                                        ul
                                        li 
                                            i Pengajuan internal BIB ditandatangani oleh pengawas area kerja & Dept. Head Custodian, kemudian divalidasi oleh OHS Operation masing-masing area.
                                        li 
                                            i Jika pengajuan izin dari mitra kerja maka harus ditandatangani oleh PJO dan penanggung jawab area, serta divalidasi dahulu oleh praktisi safety.
                                tr
                                    td(class="headerTable pl-2" rowspan="3" width="5%") Penanggung Jawab Pekerjaan
                                    td(class="headerTable align-center" width="20%") Nama
                                    td(class="headerTable align-center" width="20%") Jabatan
                                    td(class="headerTable align-center" width="20%") Tanggal
                                    td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                tr
                                    td
                                        div(class="approved")
                                            br
                                            | {{ ip.ipPemegangIzin.name }}
                                    td
                                        div(class="approved")
                                            br
                                            | {{ ip.ipPemegangIzin.position }}
                                    td
                                        div(class="approved")
                                            br
                                            | {{ approvalTime(ip.ipDate) }}
                                    td
                                        div(v-if="ip.ipStatus != '1' && ip.ipStatus != '3'" class="approved")
                                            img(src="../assets/check-64.png" style="width:25px;")
                                        div(v-else class="emptySign")
                                    td
                                WorkflowDisplay(:workflow="ip.ipWorkflow[1]" :index="1" :form-type="ip.ipForm" :show-for="false")
                                tr
                                    td(class="headerTable pl-2" rowspan="3" width="5%") Validasi Document
                                    td(class="headerTable align-center" width="20%") Nama
                                    td(class="headerTable align-center" width="20%") Jabatan
                                    td(class="headerTable align-center" width="20%") Tanggal
                                    td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                WorkflowDisplay(:workflow="ip.ipWorkflow[0]" :index="0" :form-type="ip.ipForm" :show-for="false")
                                WorkflowDisplay(:workflow="ip.ipWorkflow[2]" :index="2" :form-type="ip.ipForm" :show-for="false")
                                tr
                                    td(class="headerTable pl-2" rowspan="4" width="5%") Disetujui oleh
                                    td(class="headerTable align-center" width="20%") Nama
                                    td(class="headerTable align-center" width="20%") Jabatan
                                    td(class="headerTable align-center" width="20%") Tanggal
                                    td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                WorkflowDisplay(:workflow="ip.ipWorkflow[3]" :index="3" :form-type="ip.ipForm" :show-for="false")
                                WorkflowDisplay(:workflow="ip.ipWorkflow[4]" :index="4" :form-type="ip.ipForm" :show-for="false")
                                WorkflowDisplay(:workflow="ip.ipWorkflow[5]" :index="5" :form-type="ip.ipForm" :show-for="true")

                        table(v-else="ip.ipWorkflow.length == 4" class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable pl-2" colspan="6") VIII. PENGESAHAN
                                tr
                                    td(class="pl-2" colspan="6") 
                                        b Catatan:
                                        ul
                                        li 
                                            i Pengajuan internal BIB ditandatangani oleh pengawas area kerja & Dept. Head Custodian, kemudian divalidasi oleh OHS Operation masing-masing area.
                                        li 
                                            i Jika pengajuan izin dari mitra kerja maka harus ditandatangani oleh PJO dan penanggung jawab area, serta divalidasi dahulu oleh praktisi safety.
                                tr
                                    td(class="headerTable pl-2" rowspan="3" width="5%") Penanggung Jawab Pekerjaan
                                    td(class="headerTable align-center" width="20%") Nama
                                    td(class="headerTable align-center" width="20%") Jabatan
                                    td(class="headerTable align-center" width="20%") Tanggal
                                    td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                tr
                                    td
                                        div(class="approved")
                                            br
                                            | {{ ip.ipPemegangIzin.name }}
                                    td
                                        div(class="approved")
                                            br
                                            | {{ ip.ipPemegangIzin.position }}
                                    td
                                        div(class="approved")
                                            br
                                            | {{ approvalTime(ip.ipDate) }}
                                    td
                                        div(v-if="ip.ipStatus != '1' && ip.ipStatus != '3'" class="approved")
                                            img(src="../assets/check-64.png" style="width:25px;")
                                        div(v-else class="emptySign")
                                    td
                                WorkflowDisplay(:workflow="ip.ipWorkflow[0]" :index="0" :form-type="ip.ipForm" :show-for="false")
                                tr
                                    td(class="headerTable pl-2" rowspan="4" width="5%") Disetujui oleh
                                    td(class="headerTable align-center" width="20%") Nama
                                    td(class="headerTable align-center" width="20%") Jabatan
                                    td(class="headerTable align-center" width="20%") Tanggal
                                    td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                WorkflowDisplay(:workflow="ip.ipWorkflow[1]" :index="1" :form-type="ip.ipForm" :show-for="false")
                                WorkflowDisplay(:workflow="ip.ipWorkflow[2]" :index="2" :form-type="ip.ipForm" :show-for="false")
                                WorkflowDisplay(:workflow="ip.ipWorkflow[3]" :index="3" :form-type="ip.ipForm" :show-for="false")
                        
                        table( style="margin-top:10px;width:3cm;border: 1px solid black;" class="autoPageBreak")
                            tbody(v-if="ipDocPengesahan") 
                                v-btn(tile text @click="download(ipDocPengesahan)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-weight:normal" height="auto") 
                                    tr
                                        td(style="padding-left:1px" ) 
                                            v-icon(small) mdi-attachment
                                        td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                        td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                                            img(src="../assets/check.png" width="10" )
                            tbody(v-else)
                                tr
                                    td(style="padding-left:1px" ) 
                                        v-icon(small) mdi-attachment
                                    td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                    td(style="background-color: rgb(204,204,204);padding-right:4px" )
                                        img(src="../assets/close.png" width="10" class="verMiddle")

                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable pl-2" colspan="11") IX. PENYELESAIAN PEKERJAAN
                                tr
                                    td(class="pl-2" colspan="6") 
                                        b Catatan:
                                        ul
                                            li Pekerjaan ruang terbatas yang diajukan sudah sesuai dengan rencana dan berlangsung secara aman. 
                                            li Izin masuk ruang terbatas telah selesai dan tidak ada lagi pekerjaan yang dibutuhkan.
                        table(class="view-width tableCollapse tableInput")
                            tbody
                                tr
                                    td(class="headerTable pl-2" rowspan="4" width="5%") Pengesahan
                                    td(class="headerTable align-center" width="20%") Nama
                                    td(class="headerTable align-center" width="20%") Jabatan
                                    td(class="headerTable align-center" width="20%") Tanggal
                                    td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                tr
                                    td
                                        div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                            br
                                            | {{ ip.ipFinishedWorkflow[0].name }}
                                        //- div(v-else class="emptySign")
                                        div(v-else-if="ip.ipStatus == 10 || ip.ipStatus == 11 || ip.ipStatus == 12" class="approved")
                                            br
                                            | {{ ip.ipPemegangIzin.name }} {{ip.ipPemegangIzin2 ? '& ' + ip.ipPemegangIzin2.name : ''}}
                                    td
                                        div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                            br
                                            | {{ ip.ipFinishedWorkflow[0].title }}
                                        //- div(v-else class="emptySign")
                                        div(v-else-if="ip.ipStatus == 10 || ip.ipStatus == 11 || ip.ipStatus == 12" class="approved")
                                            br
                                            | {{ ip.ipPemegangIzin.position }} {{ip.ipPemegangIzin2 ? '& ' + ip.ipPemegangIzin2.position : ''}}
                                    td
                                        div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                            br
                                            | {{approvalTime(ip.ipFinishedWorkflow[0].date)}}
                                        //- div(v-else class="emptySign")
                                        div(v-else-if="ipClosingResubmitted !== null && ipClosingSubmitted !== null"  class="approved")
                                            br
                                            | {{ipClosingSubmitted}} , {{ipClosingResubmitted}}
                                        div(v-else-if="ip.ipStatus == 10 || ip.ipStatus == 11 || ip.ipStatus == 12" class="approved")
                                            br
                                            | {{ip.ipClosingDate ? approvalTime(ip.ipClosingDate) : " "}}
                                    td
                                        div(v-if="ip.ipFinishedWorkflow[0] ? ip.ipFinishedWorkflow[0].status == 7 : false" class="approved")
                                            img(src="../assets/check-64.png" style="width:25px;")
                                        div(v-else-if="ip.ipStatus == 10 || ip.ipStatus == 11 || ip.ipStatus == 12"  class="approved")
                                            img(src="../assets/check-64.png" style="width:25px;")
                                        div(v-else class="emptySign")
                                    td
                                        p(class="align-left top-align comment" style="width:25px;") 
                                tr
                                    td
                                        div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                            br
                                            | {{ ip.ipFinishedWorkflow[1].name }}
                                        //- div(v-else class="emptySign")
                                        div(v-else-if="ipPengesahanApproval !== null" class="approved")
                                            br
                                            | {{ ipPengesahanApproval.name }}
                                        div(v-else class="emptySign")
                                    td
                                        div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                            br
                                            | {{ ip.ipFinishedWorkflow[1].title }}
                                        //- div(v-else class="emptySign")
                                        div(v-else-if="ipPengesahanApproval !== null" class="approved")
                                            br
                                            | {{ ipPengesahanApproval.title }}
                                        div(v-else class="emptySign")
                                    td
                                        div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                            br
                                            | {{approvalTime(ip.ipFinishedWorkflow[1].date)}}
                                        //- div(v-else class="emptySign")
                                        div(v-else-if="ipPengesahanApproval !== null" class="approved")
                                            br
                                            | {{ipPengesahanApproval.date ? approvalTime(ipPengesahanApproval.date) : ''}}
                                        div(v-else class="emptySign")
                                    td
                                        div(v-if="ip.ipFinishedWorkflow[1] ? ip.ipFinishedWorkflow[1].status == 7 : false" class="approved")
                                            img(src="../assets/check-64.png" style="width:25px;")
                                        //- div(v-else class="emptySign")
                                        div(v-if="ipPengesahanApproval ? ipPengesahanApproval.status == 7 : false" class="approved")
                                            img(src="../assets/check-64.png" style="width:25px;")
                                        div(v-else class="emptySign")
                                    td
                                        p(v-if="ipPengesahanApproval !== null" class="align-left top-align comment") {{ ipPengesahanApproval.comment }}
                                        div(v-else class="emptySign" style="width:25px;")
</template>

<script>
import axios from 'axios';
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import { mapState } from 'vuex';
import printJS from 'print-js';
import { handleGlobalErrorApproval } from '../helper/handleGlobalError.js';
import WorkflowDisplay from './WorkflowDisplay.vue';

export default {
  name: 'RTViewEmail',
  components: {
    WorkflowDisplay
  },
  props: {
    dialogType: String,
    ip: Object,
    approvalUser: Object,
    activeStatus: Number,
  },
  data: () => ({
    formName: config.FormName,
    dialog: false,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    ipPengesahanApproval : null,
    ipClosingResubmitted : null,
    ipClosingSubmitted : null,
    approval: null,
    share: false,
    print: false,
    snackbar: false,
    snackbarMessage: '',
    potensiBahayaOptions: [
        'Mekanikal',
        'Hidrolik',
        'Suhu/temperatur ekstrim',
        'Elektrikal',
        'Lingkungan',
        'Api/kebakaran',
        'Penumatik',
        'Material B3',
        'Mist/Vapor'
    ],
    pengendalianBahayaOptions: [
        'Ventilasi (natural/positif/negatif)',
        'Lock Out Tag Out (LOTO)',
        'Pemisahan Bahan',
        'Rekayasa/Engineering Control (lampirkan kajian teknis)'
    ],
    alatKeselamatanOptions: [
        'Gas Detector',
        'Tangga',
        'Life Line',
        'Radio Communication',
        'Headlamp',
        'LOTO device',
        'Tripod',
        'Exhaust Fan & Duct',
        'Winch',
        'APAR',
        'Rambu - rambu'
    ],
    apdOptions: [
        'Safety Helmet bertali',
        'Sepatu Safety',
        'Sarung tangan kulit',
        'Earmuff/Earplug',
        'Kacamatan Safety',
        "Respirator (APR)",
        'Apron Las',
        'Sarung tangan kain',
        'Face Shield',
        'Full Body Harness',
        'SCBA',
        'Sarung Tangan Kimia',
        'Coverall',
        'Safety Googles',
        'Airline',
    ],
  }),
   mounted() {
        if(this.ip.ipPengesahan){
            this.ipPengesahanApproval = this.ip.ipPengesahan.ipWorkflow[0]
            this.ipClosingResubmitted = !this.ip.ipPengesahan.ipClosingResubmitted ? "" : this.approvalTime(this.ip.ipPengesahan.ipClosingResubmitted) 
            this.ipClosingSubmitted = !this.ip.ipPengesahan.ipClosingSubmitted ?  "" : this.approvalTime(this.ip.ipPengesahan.ipClosingSubmitted)
        }
    },
  computed: {
    ...mapState(['API_URL', "sharing", "networks", 'shortenUrl']),
    potensiBahayaDetail(){
      var temp = []
      for (const item of this.potensiBahayaOptions) {
        let checker = false
        for (const element of this.ip.ipPotensiBahaya) {
          if(item == element) checker = true
        }
        if(checker) temp.push(true)
        else temp.push(false)
      }
      return temp
    },
    pengendalianBahayaDetail(){
      var temp = []
      for (const item of this.pengendalianBahayaOptions) {
        let checker = false
        for (const element of this.ip.ipPengendalianBahaya) {
          if(item == element) checker = true
        }
        if(checker) temp.push(true)
        else temp.push(false)
      }
      return temp
    },
    izinKerjaKhususLainnyaDetail(){
        for(const element of this.ip.ipPengendalianBahaya){
            if(element.includes('Izin kerja khusus lainnya (sebutkan)')){
                return true;
            }
        }
        return false;
    },
    getIzinKerjaKhususLainnya(){
        for(const element of this.ip.ipPengendalianBahaya){
            if(element.includes('Izin kerja khusus lainnya (sebutkan)')){
                return element.split('|')[1];
            }
        }
        return '';
    },
    alatKeselamatanDetail(){
      var temp = []
      for (const item of this.alatKeselamatanOptions) {
        let checker = false
        for (const element of this.ip.ipAlatKeselamatan) {
          if(item == element) checker = true
        }
        if(checker) temp.push(true)
        else temp.push(false)
      }
      return temp
    },
    apdDetail(){
      var temp = []
      for (const item of this.apdOptions) {
        let checker = false
        for (const element of this.ip.ipApd) {
          if(item == element) checker = true
        }
        if(checker) temp.push(true)
        else temp.push(false)
      }
      return temp
    },
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
    ipDocPengesahan() {
      return this.ip?.ipPengesahan?.ipAttachmentFiles?.docPendukung ?? this.ip?.ipPengesahan?.ipAttachmentFiles?.docPelaporan ?? this.ip?.ipAttachmentFiles?.docPelaporan ?? null;
    }
  },
  
  methods: {
    jabatanDetail: helper.jabatanDetail,
    download(file) {
        this.$downloadFile(file, this.$route.params.token);
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css", '/stylesheets/view.css', "/stylesheets/ck-content.css"]
        });
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share, token: this.getViewToken()}).then(() => {
            this.share = true;
        });
    },
    getViewToken() {
        const splicedPathname = window.location.pathname.split('/');
        return splicedPathname[splicedPathname.length - 1];
    },
    formatDate: helper.formatDateOnly,
    getApproveStatus(wf){
        if(!this.approvalUser) return false;
        let status = 0;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik && !this.isCurrentApprover()){
                status=wf[i].status;
                break;
            }
        }
        return status;
    },
    getApproveDate(wf){
        if(!this.approvalUser) return false;
        let approvedWf = null;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                approvedWf=wf[i];
                break;
            }
        }
        return approvedWf.date;
    },
    isCurrentApprover(){
        if (!this.ip || !this.approvalUser) return false;
        const isOnApproval = Number(this.ip.ipStatus) === 2;
        const isNeedApproval = Number(this.activeStatus) === 9;
        const isOnClosing = Number(this.ip.ipStatus) === 10 && 'ipPengesahan' in this.ip && this.ip.ipPengesahan;
        const isAuthenticated = (isOnApproval && isNeedApproval) || isOnClosing;
        return helper.isApprover(
            isAuthenticated,
            this.ip,
            this.approvalUser
        );
    },
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    },
    getNameApproverKTT(item) {
        return helper.getKTTApproverName(item)
    },
    getTitleApprover(item) {
        if ( item.matrix == 'KTT' ) {
            return 'Kepala Teknik Tambang'
        } else {
            return item.title
        }
    }
  },
  watch: {
    approvalDialog2 (val) {
        if (!val) return
        if(this.ip.ipStatus == 10){
            const NewFormData = {
                formId : this.ip._id,
                status : parseInt(this.approval),
                comment : this.comment,
                approvalUser : this.approvalUser
            }
            const config = {
                method: "post",
                url: `${this.API_URL}/v1/pengesahan/approval`,
                headers: {"Authorization": `Bearer ${this.$route.params.token}`},
                data: NewFormData
            };
            axios(config).then(res => {
                if (res.status == 200) {
                    setTimeout(() => {
                        this.dialog2 = false;
                        this.dialog = false;
                        location.reload();
                    },
                    1000);
                }
            }).catch(error => {
                handleGlobalErrorApproval(error, {
                    setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                    showSnackbar: (show) => { this.snackbar = show; },
                    closeModals: () => { 
                        this.approvalDialog = false; 
                        this.approvalDialog2 = false; 
                    },
                    disableLoader: () => { 
                        this.$store.state.loader = false;
                    },
                });
            });
        }else{
            let formData = new FormData();
            formData.append('_id', this.ip._id);
            formData.append('status', parseInt(this.approval));
            formData.append('comment', this.comment);
            formData.append('approvalUser', JSON.stringify(this.approvalUser));
            formData.append('formCode', this.ip.ipForm);
            const sourceApproval = this.$route.query.sourceApproval || "";
            formData.append('sourceApproval', sourceApproval);
            const config = {
                method: "put",
                url: `${this.API_URL}/v1/requests/approval`,
                headers: {"Authorization": `Bearer ${this.$route.params.token}`},
                data: formData
            };
            axios(config).then(res => {
                if (res.status == 200) {
                    setTimeout(() => {
                        this.dialog2 = false;
                        this.dialog = false;
                        location.reload();
                    },
                    1000);
                }
            }).catch(error => {
                handleGlobalErrorApproval(error, {
                    setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                    showSnackbar: (show) => { this.snackbar = show; },
                    closeModals: () => { 
                        this.approvalDialog = false; 
                        this.approvalDialog2 = false; 
                    },
                    disableLoader: () => { 
                        this.$store.state.loader = false;
                    },
                });
            });
        }
    }
  }
};
</script>
<style scoped>
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
.mytable-footer{
      border: 1px solid black;
      border-top: 0;
      margin-top: 0;
      padding-top: 0;
      margin-bottom: 0;
      padding-bottom: 0;
}

.tableCollapse td{
    border: 1px solid black;
    border-top: 0;
    padding-left: 5px;
}
.emptySign {
    text-align: center;
    padding: 5px;
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:150px;
  left:0px;
  text-align: center;
  width: 100%;
}
.imgWatermark {
  width: 650px;
  position:absolute;
  top:0px;
  right:50px;
  opacity: 0.65;
}
.fontWatermarkUp {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  right: 200px;
  color: rgb(224,224,224);
}
.fontWatermarkDown {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  top: 450px;
  right: 100px;
  color: rgb(224,224,224);
}

.custom__position-for{
  font-size: 8px; 
  font-style: italic; 
  position: absolute; 
  bottom: 0; 
  left: 0;
}
</style>